module.exports = __webpack_public_path__ + "img/cb319091e6438f379665b60e9c2380bb.8bc4dd97.jpg";